/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpspecificndas3Inputs */

const en_coinvestments_lpspecificndas3 = /** @type {(inputs: Coinvestments_Lpspecificndas3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisation-Specific NDAs`)
};

/**
* | output |
* | --- |
* | "Organisation-Specific NDAs" |
*
* @param {Coinvestments_Lpspecificndas3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpspecificndas3 = /** @type {((inputs?: Coinvestments_Lpspecificndas3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpspecificndas3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpspecificndas3(inputs)
});
export { coinvestments_lpspecificndas3 as "coInvestments_lpSpecificNdas" }